import { render, staticRenderFns } from "./company-sso.vue?vue&type=template&id=b524c7ac&scoped=true"
import script from "./company-sso.vue?vue&type=script&lang=js"
export * from "./company-sso.vue?vue&type=script&lang=js"
import style0 from "./company-sso.vue?vue&type=style&index=0&id=b524c7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b524c7ac",
  null
  
)

export default component.exports